import { request } from "./client";

/**
 * League owners/admins customize the wording of the notification emails their league sends.
 * Each item: { category, label, description, mergeFields: [{ name, description, example }],
 * limits, defaults, current, isCustomized } where defaults/current are
 * { subject, heading, body, buttonLabel }.
 */
export const listEmailTemplates = async (leagueId) => request(`/leagues/${leagueId}/email-templates`);

export const saveEmailTemplate = async (leagueId, category, content) =>
  request(`/leagues/${leagueId}/email-templates/${category}`, { method: "PUT", body: JSON.stringify(content) });

/** Removes the customization so the built-in default is used again. */
export const resetEmailTemplate = async (leagueId, category) =>
  request(`/leagues/${leagueId}/email-templates/${category}`, { method: "DELETE" });

/**
 * Renders unsaved text with sample data. Returns { valid, errors, subject?, html?, text? }.
 * `rsvpStatus` ("NO_RESPONSE" or "YES") shows the email as a player who hasn't answered, or who is already going,
 * would see it. Only for templates that have both versions (see hasAnswerVariants); omit it otherwise.
 */
export const previewEmailTemplate = async (leagueId, category, content, rsvpStatus) =>
  request(`/leagues/${leagueId}/email-templates/${category}/preview`, {
    method: "POST",
    body: JSON.stringify(rsvpStatus ? { ...content, rsvpStatus } : content),
  });

// ── Reply-To: where replies to this league's notification emails go ───────────

/** @returns {Promise<{ replyToEmail: string | null, defaultReplyTo: string | null }>} */
export const getNotificationSettings = async (leagueId) => request(`/leagues/${leagueId}/notification-settings`);

/** Pass null or an empty string to go back to the league owner's email. */
export const saveNotificationSettings = async (leagueId, replyToEmail) =>
  request(`/leagues/${leagueId}/notification-settings`, {
    method: "PUT",
    body: JSON.stringify({ replyToEmail: replyToEmail && replyToEmail.trim() ? replyToEmail.trim() : null }),
  });

/**
 * Emails the (unsaved) wording, filled with sample data, to the signed-in organizer. Returns { sent, to?, message }.
 * `rsvpStatus` works as it does for previewEmailTemplate.
 */
export const sendEmailTemplateTest = async (leagueId, category, content, rsvpStatus) =>
  request(`/leagues/${leagueId}/email-templates/${category}/test`, {
    method: "POST",
    body: JSON.stringify(rsvpStatus ? { ...content, rsvpStatus } : content),
  });
